// URL
const EXPECTED_HOSTNAME = import.meta.env.REACT_APP_EXPECTED_HOSTNAME || location.hostname;
export const IS_HOSTNAME_MATCHING = EXPECTED_HOSTNAME === location.hostname;
export const IS_HTTPS = location.protocol === 'https:';
export const ORIGIN = import.meta.env.REACT_APP_ORIGIN || location.origin;
// Backward compatibility: support both BASE_URL (Vite) and PUBLIC_URL (CRA) during transition
export let PUBLIC_URL = import.meta.env.BASE_URL || process.env.PUBLIC_URL || '/';
PUBLIC_URL = PUBLIC_URL.endsWith('/') ? PUBLIC_URL.substring(0, PUBLIC_URL.length - 1) : PUBLIC_URL;
export const GRAFANA_NET_DOMAIN = import.meta.env.REACT_APP_DOMAIN || 'grafana.net';
export const GRAFANA_COM_DOMAIN = 'https://grafana.com';

// App
export const APP_ENVIRONMENT = import.meta.env.REACT_APP_ENVIRONMENT;
export const APP_VERSION = import.meta.env.REACT_APP_VERSION;

// APM
export const APM_ENABLED = import.meta.env.REACT_APP_APM_ENABLED === 'true';
export const FARO_ENABLED = import.meta.env.REACT_APP_FARO_ENABLED === 'true';
export const FARO_INSTRUMENTATION_CONSOLE_ENABLED =
  import.meta.env.REACT_APP_FARO_INSTRUMENTATION_CONSOLE_ENABLED === 'true';
export const FARO_INSTRUMENTATION_ERRORS_ENABLED =
  import.meta.env.REACT_APP_FARO_INSTRUMENTATION_ERRORS_ENABLED === 'true';
export const FARO_INSTRUMENTATION_RUM_ENABLED = import.meta.env.REACT_APP_FARO_INSTRUMENTATION_RUM_ENABLED === 'true';
export const FARO_INSTRUMENTATION_WEB_VITALS_ENABLED =
  import.meta.env.REACT_APP_FARO_INSTRUMENTATION_WEB_VITALS_ENABLED === 'true';
export const FARO_KEY = import.meta.env.REACT_APP_FARO_KEY;
export const FARO_URL = import.meta.env.REACT_APP_FARO_URL;
export const FARO_APP = import.meta.env.REACT_APP_FARO_APP;

// User Terms Acceptance
export const USER_TERMS_ACCEPTANCE_ENABLED = import.meta.env.REACT_APP_USER_TERMS_ACCEPTANCE_ENABLED === 'true';
/** Exact MSA `contentVersion` from LEGAL_VERSIONS for which we never show the terms modal (e.g. discarded prod test version). */
export const IGNORED_LEGAL_TERMS_CONTENT_VERSION =
  import.meta.env.REACT_APP_IGNORED_LEGAL_TERMS_CONTENT_VERSION?.trim() ?? '';

// Metrics
export const ADOBE_TARGET_DOMAIN = import.meta.env.REACT_APP_ADOBE_TARGET_DOMAIN ?? '';
export const ADOBE_TARGET_OVERRIDE_MBOX_EDGE_SERVER =
  import.meta.env.REACT_APP_ADOBE_TARGET_OVERRIDE_MBOX_EDGE_SERVER === 'true';
export const SELF_SERVE_MBOX = 'grafana-self-serve-mbox';
export const CLEARBIT_KEY = import.meta.env.REACT_APP_CLEARBIT_KEY;
export const CLEARBIT_SNIPPET_VERSION = import.meta.env.REACT_APP_CLEARBIT_SNIPPET_VERSION;
export const FACEBOOK_FBQ_VERSION = import.meta.env.REACT_APP_FACEBOOK_FBQ_VERSION;
export const FACEBOOK_KEY = import.meta.env.REACT_APP_FACEBOOK_KEY;
export const GOOGLE_TAG_MANAGER_ID = import.meta.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;
export const HOTJAR_ID = import.meta.env.REACT_APP_HOTJAR_ID
  ? parseInt(import.meta.env.REACT_APP_HOTJAR_ID, 10)
  : undefined;
export const HOTJAR_SV = import.meta.env.REACT_APP_HOTJAR_SV
  ? parseInt(import.meta.env.REACT_APP_HOTJAR_SV, 10)
  : undefined;
export const LINKEDIN_KEY = import.meta.env.REACT_APP_LINKEDIN_KEY;
export const METRICS_ENABLED = import.meta.env.REACT_APP_METRICS_ENABLED === 'true';
export const RUDDER_STACK_CONFIG_URL = import.meta.env.REACT_APP_RUDDER_STACK_CONFIG_URL;
export const RUDDER_STACK_DATA_PLANE_URL = import.meta.env.REACT_APP_RUDDER_STACK_DATA_PLANE_URL;
export const RUDDER_STACK_KEY = import.meta.env.REACT_APP_RUDDER_STACK_KEY;
export const RUDDERSTACK_INTEGRATIONS_URL = import.meta.env.REACT_APP_RUDDERSTACK_INTEGRATIONS_URL;

// OneTrust
export const OT_SOURCE = import.meta.env.REACT_APP_OT_SOURCE;
export const OT_DOMAIN = import.meta.env.REACT_APP_OT_DOMAIN;
/** Country code used instead of `/region` for local testing. Ignored in production. */
export const OT_COUNTRY_OVERRIDE = import.meta.env.REACT_APP_OT_COUNTRY_OVERRIDE;

// SSO
export const DEV_SSO_ENABLED = import.meta.env.REACT_APP_DEV_SSO_ENABLED === 'true';


// MFA
export const MFA_PROMPT_ENABLED = import.meta.env.REACT_APP_MFA_PROMPT_ENABLED === 'true';

// Cloudflare Turnstile
export const TURNSTILE_SITE_KEY = import.meta.env.REACT_APP_TURNSTILE_SITE_KEY ?? '';
export const TURNSTILE_ENABLED = import.meta.env.REACT_APP_ENABLE_TURNSTILE === 'true';

export const TURNSTILE_ACTIVE = TURNSTILE_SITE_KEY && TURNSTILE_ENABLED;

// Session Storage
export const CUSTOM_SIGNUP_CONTENT_KEY = 'customSignupContent';

// Time
export const YEAR_IN_DAYS = 365;
export const MONTH_IN_DAYS = 30;

// Rudderstack tracking events
export const CLOUD_SIGNUP_FLOW_EVENT = 'cloud_signup_flow_event';
